import styled from 'styled-components';

import Select from '_components/_core/Select/Select';

export const StyledSelect = styled(Select)`
  width: 175px !important;
`;

export default StyledSelect;
